<template>
  <management-button
    :label="withoutLabel ? '' : $t(buttonType)"
    type="execute"
    :disabled="disabled"
    @buttonClick="click"
    style="height: 25px; margin-left: 0"
  >
    <a
      v-if="buttonType === 'Download'"
      :href="fileUrl"
      style="display: none"
      id="download-file"
      download
    />
    <component
      :is="icon"
      style="height: 12px; margin-right: 2px"
      :style="{ 'margin-right': withoutLabel ? 0 : '10px' }"
    />
  </management-button>
</template>

<script>
import ManagementButton from "./ManagementButton";
import ValidateSVG from "@/assets/management/validate.svg";
import DownloadSVG from "@/assets/management/download.svg";

export default {
  name: "ManagementTableButton",

  components: { ManagementButton },

  props: {
    /**
     * If the button is disabled or not.
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Type of button
     * @values Validate, Download
     */
    buttonType: {
      type: String,
      required: true
    },

    /**
     * Determines if the button contains a label
     */
    withoutLabel: {
      type: Boolean,
      default: false
    },

    /**
     * URL of the downloadable file.
     */
    fileUrl: {}
  },

  data() {
    return {
      /**
       * Stores the icon that will be shown on the button
       */
      icon: undefined
    };
  },

  /**
   * Sets the correct icon according to the button type.
   */
  created() {
    if (this.buttonType === "Validate") this.icon = ValidateSVG;
    else if (this.buttonType === "Download") this.icon = DownloadSVG;
  },

  methods: {
    /**
     * Sends a click event to the parent component
     */
    click(e) {
      this.$emit("buttonClick", e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Management/ManagementTableButton.vue